import { render, staticRenderFns } from "./Decoration.vue?vue&type=template&id=230b44d0&scoped=true"
import script from "./Decoration.vue?vue&type=script&lang=js"
export * from "./Decoration.vue?vue&type=script&lang=js"
import style0 from "./Decoration.vue?vue&type=style&index=0&id=230b44d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230b44d0",
  null
  
)

export default component.exports